import webCert from '../assets/certs/WebDev.png';
import awsCert from '../assets/certs/AWSCCP.pdf';

export const certs = [
    { name: "AWS Cloud Practitioner", icon: "mdi:aws", link: awsCert },
    { name: "Full Stack Web Development", icon: "ant-design:code-outlined", link: webCert },
];